import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { StreetPostalAddressFormComponent } from 'src/app/core/components/street-postal-address-form/street-postal-address-form.component';
import { CheckboxFromArrayFormComponent } from 'src/app/core/components/checkbox-from-array-form/checkbox-from-array-form.component';
import { RadioFromArrayFormComponent } from 'src/app/core/components/radio-from-array-form/radio-from-array-form.component';
import { JsonDataPresenterComponent } from 'src/app/core/components/json-data-presenter/json-data-presenter.component';
import { NoWhitespaceDirective } from 'src/app/core/directives/no-whitespace.directive';
// import { ModuleLoadDirective } from 'src/app/core/directives/module-load.directive'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
          MatButtonModule, MatIconModule,
          MatAutocompleteModule, MatBadgeModule, MatBottomSheetModule, MatButtonToggleModule, MatCardModule,
          MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatDividerModule, MatExpansionModule, MatGridListModule,
          MatInputModule, MatListModule, MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressBarModule,
          MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule,
          MatSnackBarModule, MatSortModule, MatStepperModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatTreeModule,
          MatFormFieldModule
       } from '@angular/material';

import {
          MatDialogModule, MatDialogRef, MAT_DIALOG_DATA
       } from '@angular/material/dialog';
import {TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { NgxMaskModule } from 'ngx-mask';


@NgModule({
  declarations: [
      // StreetPostalAddressFormComponent,
      RadioFromArrayFormComponent,
      CheckboxFromArrayFormComponent, JsonDataPresenterComponent,
      NoWhitespaceDirective
      // ModuleLoadDirective
  ],

  bootstrap: [],
  exports  : [
        // StreetPostalAddressFormComponent,
        RadioFromArrayFormComponent,
        CheckboxFromArrayFormComponent,
        JsonDataPresenterComponent
    ],
  imports: [
    MatAutocompleteModule, MatBadgeModule, MatBottomSheetModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule,
    MatChipsModule, MatDatepickerModule, MatDividerModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule,
    MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule,
    MatSelectModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatStepperModule, MatTableModule,
    MatTabsModule, MatToolbarModule, MatTooltipModule, MatTreeModule,

    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    MatDialogModule,
    NgxMaskModule.forRoot(),
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [HttpClient]
        }
    }),
  ]
})
export class DynamicSharedModule {

}
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
